module.exports = __webpack_public_path__ + "img/instantExchange2.dec629ca.png";